export default __webpack_public_path__ + "static/media/animal@2x.c62fd885.png";